import React from "react";
import { TimelineProps } from "./types/types";
import { Typography } from "@mui/material";
import TimelineItemList from "./components/TimelineItemList";
import TimelineContainer from "./components/TimelineContainer";

const Timeline: React.FC<TimelineProps> = ({ title = "Histórico", items }) => {
  if (!items.length) return null;

  return (
    <TimelineContainer>
      <Typography variant="body1" sx={{ padding: 2 }}>
        {title}
      </Typography>
      <TimelineItemList items={items} />
    </TimelineContainer>
  );
};

export default Timeline;
